<template>
  <div class="bookings">
    <page-header title="Dispatch Management" :back="{ path: '/operations/dispatch/' }"
      breadcrumb="Dashboard > Bookings & Shipments > Dispatch Management" />

    <div class="business-status pt-4">
      <div class="">
        <div class="flex  justify-between items-center mb-8 pl-2">
          <div class="box-cover  flex items-center">
            <div :class="['color-box', { 'active': selected === 'Yes' }]" @click="selectOption('Yes')"></div>
            <p class="ml-2 text-[64px] font-bold text-[#383F51]">Long Haul</p>
          </div>
          <div class="box-cover  flex items-center">
            <div :class="['color-box', { 'active': selected === 'No' }]" @click="selectOption('No')"></div>
            <p class="ml-2 text-[14px] font-bold text-rose-500">Last Mile Shipment</p>
          </div>
        </div>

        <div v-if="selected === 'Yes'">
          <Yes :openShippingLabelAction="openShippingLabelAction" @setSelecetedDIspatch="setSelecetedDIspatch"
            @setSelecetedDetailDispatch="setSelecetedDetailDIspatch" />
        </div>

        <div v-if="selected === 'No'">
          <No :openDispatchSummaryAction="openDispatchSummaryAction" @setSelecetedLastMileDDispatch="setSelecetedLastMileDDispatch"
            @setSelecetedDetailDispatch="setSelecetedDetailDIspatch"/>
        </div>
      </div>

    </div>
    <ShippingLabel @create-dispatch="createDispatch" @open-dispatch-modal="openDispatchModal"
      :show-modal="showShippinLabel" @close-modal="showShippinLabel = false"
      :selcetdDispatchDetail="selcetdDispatchDetail" :selecetedDispatch="selecetedDispatch"
      :longHaulDispatchables="longHaulDispatchables" @open-update-status-modal="updateStatus" />


    <DispatchModal @go-back="goBack" :selecetedDispatch="selecetedDispatch" :show-modal="showDispatchModal"
      @close-modal="showDispatchModal = false" :selcetdDispatchDetail="selcetdDispatchDetail"
      :dispatchSummary="dispatchSummary" :fleetId="fleetId" />

    <UpdateConsolidationStatusModal :showmodal="showUpdateStatusModal" @close-modal="showUpdateStatusModal = false"
      :selectedItem="selectedItem" @refetchBooking="refetchOverview" />

  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import Yes from './modules/Yes.vue';
import No from './modules/No.vue';
import ShippingLabel from "../Modals/ShippingLabel.vue";
import DispatchModal from "../Modals/DispatchModal.vue";
import UpdateConsolidationStatusModal from "../Modals/update-consolidation-status.vue";


export default {
  components: {
    Yes,
    No,
    PageHeader,
    ShippingLabel,
    DispatchModal,
    UpdateConsolidationStatusModal
  },

  data() {
    return {
      type: 'long_haul',
      selecetedDispatch: [],
      selcetdDispatchDetail: [],
      showShippinLabel: false,
      showDispatchModal: false,
      showUpdateStatusModal: false,
      selected: 'Yes',
      longHaulDispatchables: [],
      selectedItem: null,
      dispatchSummary: null,
      fleetId: null
    };
  },

  methods: {
    refetchOverview() {
      this.setSelecetedDIspatch(this.selecetedDispatch)
    },
    goBack() {
      this.showShippinLabel = true;
    },
    createDispatch() {
      this.showDispatchModal = !this.showDispatchModal;
      this.getLongHaulSummary();
    },
    updateStatus(val) {
      this.selectedItem = val;
      this.showUpdateStatusModal = !this.showUpdateStatusModal;
    },

    setSelecetedDetailDIspatch(dispatchs) {
      this.selcetdDispatchDetail = dispatchs
    },
    setSelecetedDIspatch(dispatchs) {
      this.selecetedDispatch = dispatchs
      this.getConsolidatedItems({ type: this.type, consolidationId: this.selecetedDispatch[0] });
    },
    openDispatchModal() {
      this.showShippinLabel = false;
      this.showDispatchModal = true;
    },
      openDispatchSummaryAction() {
        this.showDispatchModal = true;
      },
   
    openShippingLabelAction() {
      this.showShippinLabel = true
    },
    selectOption(option) {
      this.selected = option;
    },
    selectTab(index) {
      this.selectedIndex = index;
    },
    async getConsolidatedItems(params) {
      try {
        this.loading = true;

        const response = await this.$_getDispatchableFleetOverview(params);
        this.longHaulDispatchables = response.data.data;

      
      } catch (error) {
        console.log(error);
      }
    },
    async getLongHaulSummary() {
      try {
        this.loading = true;
        const payload = {
          consolidationIds: this.selecetedDispatch
        };
        const { data: response } = await this.$_getDispatchSummary(payload);
        this.dispatchSummary = response.data
        this.fleetId = response.data.fleetInfo.id
        console.log("dispatchSummary", this.dispatchSummary);

      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    }
  },

};

</script>

<style lang="scss" scoped>
.business-status>:nth-child(1)>:nth-child(1) {
  width: 35%;
}

.color-box.active {
  background-color: #FFA600;
}

.color-box {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  border: 1px solid #C5C4D4;
  cursor: pointer;
}

.box-cover>p {
  color: #383F51;
  font-size: 14px;
  font-weight: 400;
}
</style>
